import React,{useState,useEffect,useRef} from 'react'
import Functions from './function'
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from "qrcode.react";
import Logo from '../../../images/public/websitefooter.png'
import ToothChart from '../../../components/labeltoothchart'
import CaseDetails from '../../../components/labelcasedetails'
// Deliberately imports the labadmin label's stylesheet and reuses its class rather than
// keeping a second copy here. These two labels print on the same stock and must stay
// identical; a duplicated stylesheet is what let them drift apart before (this page's own
// index.css was deleted, so it silently lost the font and the sticker sizing).
import '../../labadminprints/label/index.css'

// 4in x 3in sticker (Zebra TLP 2844-Z). See labadminprints/label/index.jsx for why this is
// injected at runtime instead of living in the stylesheet.
const LABEL_PAGE_CSS = '@page { size: 101.6mm 76.2mm; margin: 0; }';

const Index = () => {
    const [orderdata,setOrderData] = useState(null);
    const {id} = useParams();
    // useRef, not a plain let: a local would reset on every render and never guard anything,
    // so window.print() could fire more than once.
    const inprint = useRef(false);

    useEffect(()=>{
        const style = document.createElement('style');
        style.setAttribute('data-label-page','');
        style.textContent = LABEL_PAGE_CSS;
        document.head.appendChild(style);
        return ()=>{ style.remove(); };
    },[])

    useEffect(()=>{
        Functions.Get(id,(data)=>{
            setOrderData(data);
            if(!inprint.current){
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 400);
            }
            inprint.current = true;
        });
    },[id])
  return (
    <div className='labadmin_lableprint'>
    {orderdata &&
        <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <p>Invoice No: <b>{id}</b></p>
                <p>Pan No: <b>{orderdata.workingpan}</b></p>
            </div>
            {/* No contact details anywhere - see labadminprints/label/index.jsx. */}
            <div style={{border:"1px solid #000",padding:"2pt",marginTop:"2pt"}}>
                <p>Practice: <b>{orderdata.clinicname + " / " + orderdata.doctorname}</b></p>
                <p style={{fontSize:"10pt"}}>Patient: <b style={{fontSize:"10pt"}}>{orderdata.patient}</b></p>
            </div>
            <div style={{border:"1px solid #000",borderTop:"none",padding:"2pt"}}>
                <CaseDetails lineItems={orderdata.lineItems}/>
            </div>
            {/* QR beside the chart rather than on its own row - see the labadmin twin. */}
            <div style={{border:"1px solid #000",borderTop:"none",padding:"2pt"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div style={{flex:"0 0 auto"}}>
                        <ToothChart lineItems={orderdata.lineItems}/>
                    </div>
                    <div style={{flex:"0 0 auto"}}>
                        <QRCodeSVG
                            id="qrCode"
                            value={String(id)}
                            bgColor={"#ffffff"}
                            fgColor={"#000000"}
                            level={"H"}
                            includeMargin={true}
                            size={54}
                            shapeRendering="crispEdges"
                        />
                    </div>
                </div>
            </div>
            {/* The bordered FROM block went with the lab's address, email and phone; the name
                text is now the logo, which already reads "N-VISION Digital Dental Laboratory"
                - keeping both would print the name twice.
                brightness(0) forces the artwork to solid black while preserving its
                transparency. The source PNG is the brand purple, and a 203 dpi thermal head
                is 1-bit, so purple would be dithered into a grey stipple rather than printed
                as a colour. Same reason the QR is drawn as SVG. */}
            <img
                src={Logo}
                alt='N-Vision Digital Dental Laboratory'
                style={{width:"100pt", display:"block", marginTop:"3pt", filter:"brightness(0)"}}
            />
        </>
    }
    </div>
  )
}

export default Index
